import React from "react";
import { useDispatch, useSelector } from "react-redux";

import MoveSelected from "./MoveSelected";
import {
  onNodeClick,
  setCurrentNode,
  setGameAnswers,
} from "../../store/actions";
import {
  ACTIVE_COLOR,
  CURRENT_COLOR,
  END_COLOR,
  NODE_COLOR,
  ROSE_COLOR,
  START_COLOR,
} from "../../constants";
import { NodeDrawingProps } from "./types";
import {
  activeItemSelector,
  graphSelector,
  showPropertiesSelector,
} from "../../store/selectors/graphSelector";
import {
  activeGameItemSelector,
  currentNodeSelector,
  endNodeSelector,
  gameAnswersSelector,
  gameGraphSelector,
  startNodeSelector,
} from "../../store/selectors";
import { path } from "d3";

const NodeDrawing: React.FC<NodeDrawingProps> = ({
  node,
  color = NODE_COLOR,
  notClickable,
  isExpanded = false,
}) => {
  const dispatch = useDispatch();

  const activeItem = useSelector(
    !isExpanded ? activeItemSelector : activeGameItemSelector
  );
  const showProperties = useSelector(showPropertiesSelector);
  const graph = useSelector(!isExpanded ? graphSelector : gameGraphSelector);
  const endNode = useSelector(endNodeSelector);
  const startNode = useSelector(startNodeSelector);
  const currentNode = useSelector(currentNodeSelector);
  const answers = useSelector(gameAnswersSelector);

  const onMouseDown = (e: React.MouseEvent<SVGEllipseElement, MouseEvent>) => {
    if (isExpanded) {
      return;
    }
    MoveSelected.move(e, node);
    dispatch(onNodeClick(node, graph, activeItem, e.ctrlKey));
    e.stopPropagation();
  };

  const onClick = (e: React.MouseEvent<SVGEllipseElement, MouseEvent>) => {
    if (e.detail !== 2 || !isExpanded) {
      return;
    }
    console.log("double", currentNode, node);
    if (currentNode?.paths.map((path) => path.toNodeName).includes(node.name)) {
      dispatch(setGameAnswers([...answers, node]));
      dispatch(setCurrentNode(node));
    }
  };

  const getMoveableProps = () => {
    if (notClickable) return {};

    return {
      onMouseDown: (event: React.MouseEvent<SVGEllipseElement, MouseEvent>) => {
        onMouseDown(event);
      },
      onClick: (event: React.MouseEvent<SVGEllipseElement, MouseEvent>) => {
        onClick(event);
      },
      cursor: "move",
    };
  };

  const isActive = (): boolean => {
    return (
      !!activeItem &&
      activeItem.type === "NODE" &&
      node.name === activeItem.node.name
    );
  };

  const getColor = (): string => {
    if (isActive()) {
      return color;
    } else if (endNode && endNode.name === node.name) {
      return END_COLOR;
    } else if (startNode && startNode.name === node.name) {
      return START_COLOR;
    } else if (currentNode && currentNode.name === node.name) {
      return CURRENT_COLOR;
    } else if (answers.includes(node)) {
      return ROSE_COLOR;
    } else {
      return ACTIVE_COLOR;
    }
  };

  const renderTitle = (): any => {
    if (!showProperties) return null;

    return (
      <text x={node.x + 12} y={node.y + 4} className="small-svg-text">
        {node.toString()}
      </text>
    );
  };
  return (
    <g>
      <ellipse
        fill={getColor()}
        cx={node.x}
        cy={node.y}
        rx="10"
        ry="10"
        {...getMoveableProps()}
      >
        <title>{node.toString()}</title>
      </ellipse>
      {renderTitle()}
    </g>
  );
};

export default NodeDrawing;
